var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCheckboxOn = function SvgCheckboxOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0a4 4 0 0 0-4 4v16a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4H4Zm16.711 6.297a1 1 0 0 0-1.414-.008L9.895 15.58l-4.18-4.275-.093-.084a1 1 0 0 0-1.337 1.482L9.168 17.7l.094.085a1 1 0 0 0 1.324-.073l10.117-10 .084-.094a1 1 0 0 0-.076-1.32Z"
  })));
};

export default SvgCheckboxOn;